/**
 * 日期/日期时间范围选择器：在本地开发（npm run serve）时追加「近3年」快捷项，生产构建不出现。
 * 与 NODE_ENV === 'development' 对齐，无需额外 .env 配置。
 */

export function withLocalDevLongRangeDateShortcuts(baseShortcuts) {
  const list = Array.isArray(baseShortcuts) ? baseShortcuts.slice() : [];
  if (process.env.NODE_ENV === 'development') {
    list.push({
      text: '近3年（本地）',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setFullYear(start.getFullYear() - 3);
        picker.$emit('pick', [start, end]);
      }
    });
  }
  return { shortcuts: list };
}

/** 用于 datetimerange（起 00:00:00，止 23:59:59.999） */
export function withLocalDevLongRangeDateTimeShortcuts(baseShortcuts) {
  const list = Array.isArray(baseShortcuts) ? baseShortcuts.slice() : [];
  if (process.env.NODE_ENV === 'development') {
    list.push({
      text: '近3年（本地）',
      onClick(picker) {
        const end = new Date();
        end.setHours(23, 59, 59, 999);
        const start = new Date();
        start.setFullYear(start.getFullYear() - 3);
        start.setHours(0, 0, 0, 0);
        picker.$emit('pick', [start, end]);
      }
    });
  }
  return { shortcuts: list };
}
